// Model.js
// -----------------------
// @module Case
define("Room4.CCACategoryDescriptionFooter.SS2Model", [
  "Backbone",
  "Utils",
], function (Backbone, Utils) {
  "use strict";

  return Backbone.Model.extend({
    //@property {String} urlRoot
    urlRoot: Utils.getAbsoluteUrl(
      getExtensionAssetsPath(
        "Modules/CategoryDescriptionFooter/SuiteScript2/Room4.CCACategoryDescriptionFooter.Service.ss"
      ),
      true
    ),
  });
});
